import { useEffect, useRef, useState } from "react";
import UnAuthComponent from "../layout/unauth.component";
import { ViewTextLabels, appNote, buttonLabels } from "../shared/constants";
import { ArrowForwordIcon, FbIcon, GoogleLoginIcon, HidePassword, InstaIcon, LinkdinIcon, MicrosoftLoginIcon2, ShowPassword, WebIcon, YoutubeIcon, FalkonchatIcon, LoginBgMobile, } from "../../icon";
import { Checkbox, FormControlLabel, FormHelperText, InputAdornment, TextField, Tooltip, Zoom } from "@mui/material";
import { Link } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import { validateForm } from "../shared/form-validation";
import { useNavigate } from "react-router";
import { ChannelAuthService } from "../../services/ChannelAuthService";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { ChannelUserService } from "../../services/ChannelUserService";
import LoginTopCurves from "../../icons/login-background-top-curves.svg";
import LoginBottomCurves from "../../icons/login-background-bottom-curves.svg";
import FalkonchatLoginIcon from "../../icons/channels-login-icon.svg";
import FalkonchatSignUpIcon from "../../icons/channels-signup-icon.svg";



const ChannelsLoginComponent = () => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsWordPress: boolean = useSelector(selector.IsWordpress)
    const IsShopify: boolean = useSelector(selector.IsShopify)



    const navigate = useNavigate();
    const [state, setState] = useState<any>({
        email: "",
        password: "",
        keepLogin: true,
        showError: false,
        showPassword: false,
        errorDescription: '',
        errors: {
            email: "",
            password: "",
        },
        IsLoading: false,
        IsSSOLoading: false,
        isDownloadIconHovered: {
            name: "",
            isHovered: false
        },
        hostingEnvironment: 'unknown',
    });

    const sliderRef = useRef();

    useEffect(() => {
        const slider: any = sliderRef.current;
        let interval = setInterval(() => {
            if (slider) {
                slider.scrollBy({ left: slider.offsetWidth, behavior: 'smooth' });
                if (slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth) {
                    slider.scrollTo({ left: 0, behavior: 'smooth' });
                }
            }
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const socialLogins = [
        { Name: "Google", Icon: <GoogleLoginIcon className="mr-2 h-p-100" />, onclick: () => ChannelAuthService.getGoogleUrl(window.location.pathname.startsWith("/teams"), navigate) },
        { Name: "Microsoft", Icon: <MicrosoftLoginIcon2 className="mr-2 h-p-100" />, onclick: () => ChannelAuthService.getMicrosoftUrl(window.location.pathname.startsWith("/teams"), navigate) }
    ]

    const handleChange = (name: string, value: any) => {
        validateForm({ [name]: value },
            (errors) => {
                setState((prevState) => ({ ...prevState, errors: { ...state.errors, ...errors } }))
            })
        setState((prevState) => ({ ...prevState, [name]: value }));
    };


    const onClickShowPassword = () => {
        setState((prevState) => ({ ...prevState, showPassword: !state.showPassword }));
    }

    const login = (event) => {
        event.preventDefault();

        if (
            validateForm(
                { email: state.email, password: state.password },
                (errors) => {
                    setState((prevState) => ({ ...prevState, errors: { ...prevState.errors, ...errors }, showError: false }));
                }
            )
        ) {
            setState((prevState) => ({
                ...prevState,
                IsLoading: true,
                showError: false,
            }));

            setState({ ...state, IsLoading: true })
            ChannelAuthService.ChannelLogin(state.email, state.password, state.keepLogin, navigate).then((res) => {
                setState({ ...state, IsLoading: false })
            }).catch((err) => {
                setState({ ...state, IsLoading: false })
                if (err.response.data.error === "invalid username") {
                    setState({ ...state, errorDescription: appNote.INVALID_EMAIL })
                }
                else if (err.response.data.error === "invalid password") {
                    setState({ ...state, errorDescription: appNote.INVALID_PASWORD })
                }
                else if (err.response.data.error === "user is disabled") {
                    setState({ ...state, errorDescription: "sorry, your account disabled contact to your manger!" })
                }
                else if (err.response.data.error === "user is deleted") {
                    setState({ ...state, errorDescription: "sorry, your account deleted contact to your manger!" })
                }
            })
        }
    }

    useEffect(() => {
        if (!!ChannelAuthService.isUserLoggedIn()) {
            navigate(ChannelUserService.hasSysAdminRole() ? AppRoutes.CHANNELS_ORGANISATIONS : IsWordPress ? AppRoutes.CHANNELS : AppRoutes.CHANNELS_DASHBOARD)
        }
        else {
            navigate(AppRoutes.CHANNELS_SIGN_IN);
            localStorage.removeItem("user-token")
            localStorage.removeItem("current-user")
            localStorage.removeItem("Timezone")
            localStorage.removeItem("IsLiveChat")
        }
    }, [])

    return (
        <div className={`d-flex w-p-100 h-v-100 ${IsMobileDevice && "flex-direction"}`}>
            {!IsMobileDevice &&
                <div className="w-p-45 h-p-100 bg-color-login-left-background d-flex flex-direction">
                    <div className={`h-p-10 d-flex align-end pl-6`}>
                        <FalkonchatIcon />
                    </div>
                    <div className="d-flex flex-direction w-p-100 h-p-75 slider" ref={sliderRef}>
                        <div className="w-p-100 h-p-100 d-flex">
                            <div className="h-p-100 w-p-100 d-flex flex-direction slide" >
                                <div className="w-p-100 h-p-25 d-flex flex-direction justify-center align-center">
                                    <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                        Engage,Convert,Repeat:
                                    </div>
                                    <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                        Boost sales with Falkon Chat
                                    </div>
                                    <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center mt-1"}>
                                        provide immediate assistance with omnichannel live chat,
                                    </div>
                                    <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center"}>
                                        resolving customer queries in real-time.
                                    </div>
                                </div>
                                <div className="d-flex justify-center align-center h-p-75 w-p-100">
                                    <img src={FalkonchatLoginIcon} className="h-p-100 w-p-100" />
                                </div>
                            </div>
                            <div className="h-p-100 w-p-100 d-flex flex-direction slide" >
                                <div className="w-p-100 h-p-25 d-flex flex-direction justify-center align-center">
                                    <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                        Turn a curious Visitor
                                    </div>
                                    <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                        into a valuable customer
                                    </div>
                                    <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center mt-1"}>
                                        connect with website visitors exactly when
                                    </div>
                                    <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center"}>
                                        they,re browsing your product or services.
                                    </div>
                                </div>
                                <div className="d-flex justify-center align-center h-p-75 w-p-100">
                                    <img src={FalkonchatSignUpIcon} className="h-p-90 w-p-100" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-p-100 min-h-12 d-flex flex-direction h-p-15">
                        <div className="w-p-100 h-p-20 d-flex justify-center align-center color-login-text-field-font h6-medium">
                            {/* Download now */}
                        </div>
                        <div className="w-p-60 h-p-40 d-flex align-center justify-around mx-auto">
                            {/* <div>
                                <a href='https://www.falkonsms.com/'
                                    data-arrow-index={1}
                                    data-up-arrow-index={1}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={1}
                                    data-right-arrow-index={2}
                                    className={"text-style"} target="_blank" rel="noopener noreferrer">
                                    <Tooltip title='Website' placement='bottom-end' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                        <WebIcon />
                                    </Tooltip>
                                </a>
                            </div>
                            <div >
                                <a href='https://www.facebook.com/falkonsystems2021'
                                    data-arrow-index={2}
                                    data-up-arrow-index={2}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={1}
                                    data-right-arrow-index={3}
                                    className={"text-style"} target="_blank" rel="noopener noreferrer">
                                    <Tooltip title='Facebook' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                        <FbIcon />
                                    </Tooltip>
                                </a>
                            </div>
                            <div >
                                <a href='https://www.linkedin.com/company/falkon-systems/'
                                    data-arrow-index={3}
                                    data-up-arrow-index={3}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={2}
                                    data-right-arrow-index={4}
                                    className={"text-style"} target="_blank" rel="noopener noreferrer">
                                    <Tooltip title='Linkdin' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                        <LinkdinIcon />
                                    </Tooltip>
                                </a>
                            </div>
                            <div >
                                <a href='https://www.instagram.com/falkon_systems_/'
                                    data-arrow-index={4}
                                    data-up-arrow-index={2}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={3}
                                    data-right-arrow-index={5}
                                    className={"text-style"} target="_blank" rel="noopener noreferrer">
                                    <Tooltip title='Instagram' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                        <InstaIcon />
                                    </Tooltip>
                                </a>
                            </div>
                            <div >
                                <a href='https://www.youtube.com/channel/UCP_hOtnoImVPCleutK9mLtA'
                                    data-arrow-index={5}
                                    data-up-arrow-index={2}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={4}
                                    data-right-arrow-index={6}
                                    className={"text-style"} target="_blank" rel="noopener noreferrer">
                                    <Tooltip title='Youtube' placement='bottom-start' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                        <YoutubeIcon />
                                    </Tooltip>
                                </a>
                            </div> */}
                        </div >
                    </div >
                </div >
            }
            {IsMobileDevice &&
                <div className={`h-p-10 d-flex align-end pl-6`}>
                    <FalkonchatIcon />
                </div>
            }
            {IsMobileDevice &&
                <div className="p-absolute l-0 b-0" style={{ zIndex: -1 }}>
                    <LoginBgMobile />
                </div>
            }
            <div className={`${IsMobileDevice ? "w-p-100 h-p-90 justify-center" : "h-p-100 w-p-55 justify-flex-end"} d-flex  flex-direction align-center p-relative`}>
                {
                    !IsMobileDevice &&
                    <div className="p-absolute t-0 l-0 w-30" style={{ zIndex: -1 }}>
                        <img src={LoginTopCurves} alt="" className="w-p-100" />
                    </div>
                }
                {
                    !IsMobileDevice &&
                    <div className="p-absolute b-0 r-0 w-60" style={{ zIndex: -1 }}>
                        <img src={LoginBottomCurves} alt="" className="w-p-100" />
                    </div>
                }
                <form onSubmit={(e) => login(e)} className={`w-p-100 h-p-100 d-flex flex-direction ${IsMobileDevice ? "justify-center" : "justify-flex-end"} align-center`} >
                    <div className={`w-p-100 d-flex flex-direction justify-center ${IsMobileDevice ? "" : "h-p-75 pb-2"}`}>
                        <div className={` ${IsWordPress ? "h-p-10" : "h-p-10"} min-h-10 d-flex justify-center align-start h1-semibold color-login-headers mx-auto ${IsMobileDevice ? "w-p-100" : "w-p-70"}`}>
                            Sign In to Falkon Chat
                        </div>
                        <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <TextField
                                className={`w-p-100 h-p-100 unauth-border ${state.errors.email && "unauth-border-error"}`}
                                error={
                                    !!state.errors.email
                                }
                                variant="standard"
                                fullWidth
                                id="email"
                                placeholder=""
                                name="email"
                                autoComplete={""}
                                label="Business Email*"
                                autoFocus
                                value={state.email}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                inputProps={{ tabIndex: 1, "data-arrow-index": 6 }}
                                InputProps={{
                                    classes: { input: 'h4-regular w-p-100' }
                                }}
                            />
                        </div>
                        <div className={`h-p-2 min-h-3 mx-auto ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <FormHelperText className="h6-regular color-primary-danger ml-auto">
                                {state.errors.email}
                            </FormHelperText>
                        </div>
                        <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <TextField
                                className={`w-p-100 h-p-100 unauth-border ${state.errors.email && "unauth-border-error"} disableEdgeIcon`}
                                error={
                                    !!state.errors.password
                                }
                                variant="standard"
                                fullWidth
                                name="password"
                                type={state.showPassword ? "text" : "password"}
                                id="password"
                                autoComplete="current-password"
                                label="Password*"
                                value={state.password}
                                onChange={(e) => handleChange(e.target.name, e.target.value)} InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='start' className="c-pointer" onClick={onClickShowPassword}>
                                            {state.showPassword ? <HidePassword /> : <ShowPassword />}
                                        </InputAdornment>),
                                    classes: { input: 'h4-regular w-p-100' }
                                }}
                                inputProps={{ maxLength: 20, tabIndex: 2, "data-arrow-index": 7 }}
                                title=""
                            />
                        </div>
                        <div className={`${IsWordPress ? "h-p-4 min-h-4" : "h-p-4 min-h-4"} d-flex align-center mx-auto ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <div className={" d-flex  align-center h5-bold color-login-secondary w-space"}>
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {state.errors.password}
                                </FormHelperText>
                            </div>
                            <div className="ml-auto">
                                <Link tabIndex={5}
                                    data-arrow-index={10}
                                    data-up-arrow-index={6}
                                    data-down-arrow-index={7}
                                    data-left-arrow-index={2}
                                    data-right-arrow-index={10}
                                    to={AppRoutes.CHANNELS_FORGET_PASSWORD} className={"color-login-link c-pointer text-style w-space h5-regular f-link-hover"}> {appNote.FORGOT_YOUR_PASSWORD} </Link>
                            </div>
                        </div>
                        <div className={`h-p-6 min-h-4 d-flex align-center mx-auto ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <FormControlLabel classes={{ label: "w-space h5-regular color-keepme-sign-label" }} control={
                                <Checkbox
                                    checked={state.keepLogin}
                                    value={state.keepLogin}
                                    onChange={(e: any) => setState((prevState) => ({ ...prevState, keepLogin: e.target.checked }))}
                                    inputProps={{ tabIndex: 3, "data-arrow-index": 8, "data-up-arrow-index": 7, "data-down-arrow-index": 9, "data-left-arrow-index": 2, "data-right-arrow-index": 8 } as any}
                                    classes={{ checked: "selected-checkbox" }} name="keepSignedIn" />}
                                label="Keep me signed in" />
                        </div>
                        <div className={`mx-auto h-p-6 min-h-6 d-flex align-center ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <button
                                data-arrow-index={9}
                                data-up-arrow-index={8}
                                data-down-arrow-index={9}
                                data-left-arrow-index={2}
                                data-right-arrow-index={9}
                                tabIndex={4}
                                onClick={(e) => login(e)}
                                type="submit"
                                className={`c-pointer justify-center d-flex w-space h4-regular w-fill br-2 t-align-center bg-color-login-btn color-secondary w-p-100 align-center h-p-80`}>
                                {state.IsLoading && <span className="mr-1 loader-primary my-auto"></span>}
                                <span className={"my-auto mr-1"}>Sign In</span>
                                <ArrowForwordIcon />
                            </button>
                        </div>
                        <div className={`h-p-2 min-h-2 t-align-center h5-regular d-flex justify-center align-center mx-auto color-primary-danger ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            {state.errorDescription}
                        </div>
                        <div className={`h-p-6 min-h-4 d-flex justify-center align-center h5-regular color-primary-accent mx-auto w-space ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                            <span >
                                {appNote.DONT_HAVE_AN_ACCOUNT}&nbsp;&nbsp;
                            </span>
                            <span>
                                {IsWordPress ?
                                    <div className={"color-login-link c-pointer text-style w-space m-auto"} onClick={() => window.open(AppRoutes.CHANNELS_SIGN_UP, "_blank")}>
                                        {ViewTextLabels.SIGN_UP}
                                    </div> :
                                    <Link tabIndex={5}
                                        data-arrow-index={10}
                                        data-up-arrow-index={6}
                                        data-down-arrow-index={7}
                                        data-left-arrow-index={2}
                                        data-right-arrow-index={10}
                                        to={AppRoutes.CHANNELS_SIGN_UP}
                                        className={"color-login-link c-pointer text-style w-space m-auto"}>
                                        {ViewTextLabels.SIGN_UP}
                                    </Link>
                                }
                            </span>
                        </div>

                        {!IsWordPress && !IsShopify &&
                            <div className={`h-2 mb-3 mx-auto d-flex justify-center h5-regular ${IsMobileDevice ? "w-p-70" : "  min-w-50"}`}>
                                <div className={`h-2 mx-auto bb-primary-background-pink-4 d-flex justify-center h5-regular w-p-45`}>
                                </div>
                                <div className=" min-w-6 h-2 d-flex justify-center align-center p-relative t-1 color-primary-accent w-space w-p-10">
                                    or
                                </div>
                                <div className={`h-2 mx-auto bb-primary-background-pink-4 d-flex justify-center h5-regular w-p-45`}>
                                </div>
                            </div>
                        }

                        {!IsWordPress && !IsShopify &&
                            socialLogins.map((x) => {
                                return (
                                    <div className={`mx-auto h-p-6 min-h-6 d-flex align-center ${IsMobileDevice ? "w-p-70" : "  min-w-50"} c-pointer`} onClick={x.onclick}>
                                        <div className="social-login-button w-p-100 h-p-80 color-microsoft-inactive-email h5-medium">
                                            {x.Icon} Login with {x.Name}
                                        </div>
                                    </div>)
                            })
                        }
                    </div>
                    {!IsMobileDevice &&
                        <div className={`mx-auto h-p-15 d-flex flex-direction align-center ${IsMobileDevice ? "w-p-80" : "  min-w-50 min-h-12"}`}>
                            <div className={`h-p-20 w-p-100 d-flex align-end justify-around h6-medium ${IsMobileDevice ? "w-p-80" : "  min-w-50"}`}>
                                <div   >
                                    <a href='https://falkonsystems.com/terms-of-service/'
                                        target="_blank"
                                        data-arrow-index={3}
                                        data-up-arrow-index={1}
                                        data-down-arrow-index={1}
                                        data-left-arrow-index={5}
                                        data-right-arrow-index={4}
                                        className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                        {buttonLabels.TERMS_OF_SERVICE}
                                    </a>
                                </div>
                                <div   >
                                    <a href='https://falkonsystems.com/privacy-policy/'
                                        target="_blank"
                                        data-arrow-index={4}
                                        data-up-arrow-index={2}
                                        data-down-arrow-index={2}
                                        data-left-arrow-index={3}
                                        data-right-arrow-index={5}
                                        className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                        {buttonLabels.PRIVACY_POLICY}
                                    </a>
                                </div>
                                <div   >
                                    <a href='https://falkonsystems.com/acceptable-use-policy/'
                                        target="_blank"
                                        data-arrow-index={5}
                                        data-up-arrow-index={2}
                                        data-down-arrow-index={4}
                                        data-left-arrow-index={4}
                                        data-right-arrow-index={9}
                                        className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                        {"Acceptable Use Policy"}
                                    </a>
                                </div>
                            </div>

                            <div className={`h-p-40 min-h-6 d-flex align-center justify-around mx-auto ${IsMobileDevice ? "w-p-80" : "  min-w-30 max-w-30"}`}>
                                {/* <div>
                                    <a href='https://www.falkonsms.com/'
                                        data-arrow-index={1}
                                        data-up-arrow-index={1}
                                        data-down-arrow-index={0}
                                        data-left-arrow-index={1}
                                        data-right-arrow-index={2}
                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                        <Tooltip title='Website' placement='bottom-end' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                            <WebIcon />
                                        </Tooltip>
                                    </a>
                                </div> */}
                                <div >
                                    <a href='https://www.facebook.com/falkonsystems2021'
                                        data-arrow-index={2}
                                        data-up-arrow-index={2}
                                        data-down-arrow-index={0}
                                        data-left-arrow-index={1}
                                        data-right-arrow-index={3}
                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                        <Tooltip title='Facebook' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                            <FbIcon />
                                        </Tooltip>
                                    </a>
                                </div>
                                <div >
                                    <a href='https://www.linkedin.com/company/falkon-systems/'
                                        data-arrow-index={3}
                                        data-up-arrow-index={3}
                                        data-down-arrow-index={0}
                                        data-left-arrow-index={2}
                                        data-right-arrow-index={4}
                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                        <Tooltip title='Linkdin' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                            <LinkdinIcon />
                                        </Tooltip>
                                    </a>
                                </div>
                                {/* <div >
                                    <a href='https://www.instagram.com/falkon_systems_/'
                                        data-arrow-index={4}
                                        data-up-arrow-index={2}
                                        data-down-arrow-index={0}
                                        data-left-arrow-index={3}
                                        data-right-arrow-index={5}
                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                        <Tooltip title='Instagram' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                            <InstaIcon />
                                        </Tooltip>
                                    </a>
                                </div> */}
                                <div >
                                    <a href='https://www.youtube.com/channel/UCP_hOtnoImVPCleutK9mLtA'
                                        data-arrow-index={5}
                                        data-up-arrow-index={2}
                                        data-down-arrow-index={0}
                                        data-left-arrow-index={4}
                                        data-right-arrow-index={6}
                                        className={"text-style"} target="_blank" rel="noopener noreferrer">
                                        <Tooltip title='Youtube' placement='bottom-start' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                            <YoutubeIcon />
                                        </Tooltip>
                                    </a>
                                </div>
                            </div >
                        </div>
                    }
                </form>
            </div >
        </div >
    )
}

export default ChannelsLoginComponent;